import { Language, extractErrorMessage } from '@loyalty/shared-common';
import {
  ProfileInteractionPayload,
  compileInteractionDetailTemplate,
} from '@loyalty/shared-common/profile-api-client';

export type DetailTemplatePreviewErrorType = 'invalid-json' | 'handlebars';

export interface DetailTemplatePreviewError {
  type: DetailTemplatePreviewErrorType;
  message: string;
}

export type DetailTemplatePreviewResult =
  | { ok: true; html: string }
  | { ok: false; error: DetailTemplatePreviewError };

export function compileDetailTemplatePreview(
  template: string,
  samplePayloadJson: string,
  language: Language = Language.en,
): DetailTemplatePreviewResult {
  let payload: ProfileInteractionPayload;

  try {
    payload = JSON.parse(samplePayloadJson) as ProfileInteractionPayload;
  } catch (error) {
    return {
      ok: false,
      error: {
        type: 'invalid-json',
        message: extractErrorMessage(error as Error) ?? String(error),
      },
    };
  }

  try {
    const html = compileInteractionDetailTemplate(template, payload, language);
    return { ok: true, html };
  } catch (error) {
    return {
      ok: false,
      error: {
        type: 'handlebars',
        message: extractErrorMessage(error as Error) ?? String(error),
      },
    };
  }
}
